import { useTranslation } from "react-i18next";
import Modal from "../../components/Modal";
import { Divider, Text } from "@chakra-ui/react";
import { getTransactionsTypeIcon } from "../../globals/transactions";
import dayjs from "dayjs";
import { BillRendered } from "./Bills";
import { TransactionType } from "../../utils/types.global";

interface NewBillViewModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: BillRendered | undefined
}

const BillViewModal = (props: NewBillViewModalProps) => {
    const { t } = useTranslation("translations");

    return (
        <>
            <Modal
                header={t("VIEW_BILL_TRANSACTIONS")}
                isOpen={props.isOpen}
                onClose={props.onClose}
                size={'4xl'}
            >

                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2">{t("BILL_TYPE")}:</Text>
                    {/*@ts-ignore*/}
                    <Text> {props.data?.transactions.length > 0 ? t(TransactionType[props.data?.transactions[0].type]) : "-"} </Text>
                </div>
                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2">{t("NO")}:</Text>
                    <Text> {props.data?.billNo} </Text>
                </div>
                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2"> {t("COMPANY_NAME")}:</Text>
                    <Text> {props.data?.companyName} </Text>
                </div>

                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2"> {t("PLACE_OF_BUSINESS")}:</Text>
                    <Text> {props.data?.placeOffBusinessName} </Text>
                </div>
                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2">{t("BILL_DATE")}:</Text>
                    <Text> {props.data?.billDate} </Text>
                </div>
                <div className="flex flex-row m-4">
                    <Text fontSize='md' as="b" className="mr-2"> {t("CREATED_AT")}:</Text>
                    <Text> {props.data?.createdAt} </Text>
                </div>

                <>
                    {
                        props.data?.billAditionalDetails &&
                            <>
                                <Divider className="m-2"/>
                                <Text fontSize='xl' as="b" className="m-4">{t("BUYER_DETAILS")}</Text>
                                <div className="flex flex-row m-4">
                                    <Text fontSize='md' as="b" className="mr-2"> {t("BILL_BUYER_NAME")}:</Text>
                                    <Text> {props.data?.billAditionalDetails.buyerName} </Text>
                                </div>
                                <div className="flex flex-row m-4">
                                    <Text fontSize='md' as="b" className="mr-2"> {t("BILL_BUYER_LOCATION")}:</Text>
                                    <Text> {props.data?.billAditionalDetails.buyerLocation} </Text>
                                </div>
                                <div className="flex flex-row m-4">
                                    <Text fontSize='md' as="b" className="mr-2"> {t("CUI")}:</Text>
                                    <Text> {props.data?.billAditionalDetails.cui} </Text>
                                </div>
                            </>
                    }
                </>

                <Divider className="m-2"/>
                <div>
                    <Text fontSize='xl' as="b" className="m-4">{t("TRANSACTIONS")}</Text>
                    {
                        props.data?.transactions.map((c: any, index: number) => {
                            return (
                                <div key={`transaction_${index}`} className="flex flex-col md:flex-row bg-teal-300/20 m-2 rounded-xl p-4 md:p-2 items-start md:items-center justify-between text-[14px]">
                                    <div className="py-2 px-4 bg-white/80 rounded-full mr-2 relative my-4 md:my-0 w-[100%] md:w-[15%]">
                                        {getTransactionsTypeIcon(c.type, t)}
                                    </div>
                                    <div className="flex flex-row md:w-[30%] mx-4 my-2 md:m-0 font-bold">
                                        {c.productName.toUpperCase()}
                                    </div>
                                    <div className="flex flex-row w-[50%] md:w-[15%] mx-4 my-2 md:m-0">
                                        {c.quantity} ({c.productUM})
                                    </div>
                                    <div className="md:w-[10%] mx-4 my-2 md:m-0">
                                        {c.price} (RON)
                                    </div>
                                    <div className="md:w-[10%] mx-4 my-2 md:m-0">
                                        {c.userName}
                                    </div>
                                    <div className="mx-4 my-2 md:m-0">
                                        {dayjs(c.createdAt).format("DD-MM-YYYY HH:mm")}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>


            </Modal>
        </>

    )
}


export default BillViewModal;
